<template>
  <div class="g-layout-sider-menu-content">
    <!-- 菜单 -->
    <div class="g-layout-sider-menu">
      <ul v-for="item in (menu || {}).routes" :key="item.path">
        <li
          class="first"
          :class="filterItem(item.children) ? 'open' : ''"
          :id="`g_menu_${item.name}`"
        >
          <!-- 有子菜单 -->
          <a
            href="javascript:;"
            v-if="item.meta && item.meta.hasChildrenMenu"
            @click="menuClick(`g_menu_${item.name}`)"
          >
            <Icon :type="item.meta.icon" v-if="item.meta.icon" />
            <span>{{ $t(item.meta.title) }}</span>
          </a>

          <!-- 一级菜单 -->
          <router-link
            :to="{ name: item.name }"
            :class="filterItem(item.children) ? `router-link-active-parent` : ''"
            v-else
          >
            <Icon :type="item.meta.icon" v-if="item.meta.icon" />
            <span>{{ $t(item.meta.title) }}</span>
          </router-link>

          <!-- 子菜单，循环 -->
          <MenuItem :data="item.children" v-if="filterItem(item.children)" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { filterChildren } from '@/libs/utils';
import MenuItem from './MenuItem.vue';
import Config from '@/config';

export default {
  props: {
    menu: {
      type: [Object, Array],
      default: null,
    },
  },
  components: {
    MenuItem,
  },
  data() {
    return {
      Config,
      rootSubmenuKeys: [],
      selectedKeys: [],
      openKeys: [],

      // 活动父级
      activeParent: null,

      collapsed: false,
    };
  },
  beforeMount() {
    const currentUrl = this.$route.name ? this.$route.path : location.pathname;
    // 菜单路由处理
    this.setSidebar(currentUrl);
    // 当前选中
    this.selectedKeys = [currentUrl];

    this.setRouter(this.$route);
  },
  computed: {
    ...mapGetters(['siderOpenKeys', 'userInfo', 'authList']),
    hasEditAuth() {
      return this.authList.includes('auth_my') && this.authList.includes('auth_my_info');
    },
  },
  watch: {
    // 监听路由变化，变更菜单当前选中
    $route: function(item) {
      this.setRouter(item);
    },
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    ...mapMutations(['setSidebar', 'setSiderOpenKeys']),

    filterItem(children) {
      return filterChildren(children, this.authList);
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);

      if (latestOpenKey) {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      } else {
        this.openKeys = [];
      }
      this.setSiderOpenKeys(this.openKeys);
    },

    // 菜单点击
    menuClick(id) {
      const element = document.getElementById(id);
      const className = element?.getAttribute('class');
      if (/open/gi.test(className)) {
        element.setAttribute('class', className.replace(' open', ' close'));
      } else {
        element.setAttribute('class', className.replace(' close', ' open'));
      }
      return false;
    },

    setRouter(item) {
      if (item.matched) {
        item.matched.map(route => {
          if (route.name === item.name) {
            if (route.parent && route.parent.redirect && route.parent.parent) {
              this.activeParent = route.parent.parent;
            } else {
              this.activeParent = route.parent;
            }
          }
        });
      }
    },

    gotoMy() {
      if (this.hasEditAuth) {
        this.$router.push({
          name: 'My',
        });
      }
    },
  },
};
</script>
